// extracted by mini-css-extract-plugin
export var numberInputContainer = "_6d-0";
export var startPickingButton = "_6d-1";